<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <el-form ref="form" :rules="rules" :model="form" label-width="160px" class="demo-ruleForm"
      :label-position="labelPosition">
      <el-collapse v-model="activeNames">
        <el-collapse-item title="基础信息" name="1">
          <el-row :gutter="20">
            <el-col :span="6" :offset="8">
              <el-form-item label="应用" prop="appid">
                <el-select v-model="form.appid" @change="changeAppid" @clear="form.appid = ''" clearable
                  :popper-append-to-body="false" :disabled="appDisabled" filterable>
                  <el-option v-for="(item, index) in application" :key="index" :label="item.title"
                    :value="item.id"></el-option>
                </el-select>
                <!-- <el-input v-model.trim="form.name"></el-input> -->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" :offset="8">
              <el-popover placement="left" width="200" trigger="hover" content="仅在选择一个应用时可用" :disabled="versionPopover">
                <el-form-item label="版本号" prop="version" slot="reference">
                  <el-select v-model="form.version" :disabled="versionNum" clearable @change="versionChange" filterable>
                    <el-option v-for="(item, ind) in versionV2" :key="ind" :value="item" :label="item"></el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item label="版本号" prop="version" slot="reference">
                  <el-input v-model="form.version" :disabled="versionNum" clearable @change="versionChange" filterable>
                    <el-option v-for="(item, ind) in versionV2" :key="ind" :value="item" :label="item"></el-option>
                  </el-input>
                </el-form-item> -->
              </el-popover>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" :offset="8">
              <el-form-item label="时间" prop="date">
                <el-date-picker v-model="form.date" type="date" placeholder="请选择" format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" clearable></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" :offset="8">
              <el-form-item label="产品负责人" prop="product_admin_id">
                <el-select v-model="form.product_admin_id" clearable filterable>
                  <el-option v-for="item in authorList" :key="item.id" :label="item.realname"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row :gutter="20">
            <el-col :span="6" :offset="8">
              <el-form-item label="增长协作者">
                <el-select v-model="form.collaborator" clearable filterable>
                  <el-option
                    v-for="item in authorList"
                    :key="item.id"
                    :label="item.realname"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row> -->
          <!-- <el-row :gutter="20">
            <el-col :span="6" :offset="8">
              <el-form-item label="商业化协作者" >
                <el-select v-model="form.commercial" clearable filterable>
                  <el-option
                    v-for="item in authorList"
                    :key="item.id"
                    :label="item.realname"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row :gutter="20">
            <el-col :span="8" :offset="8">
              <el-form-item label="备注">
                <el-input type="textarea" v-model="form.remarks" placeholder="请输入" :maxlength="2000" show-word-limit
                  clearable :autosize="{ minRows: 3 }"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>

        <el-collapse-item title="更新内容" name="2">
          <el-row :gutter="20">
            <el-col :span="6" :offset="9">
              <h4 style="
                  font-weight: 400;
                  color: #f56c6c;
                  transform: translateX(-12px);
                " class="required">
                以下更新内容必填一项
              </h4>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8" :offset="8">
              <el-form-item label="产品功能更新" hide-required-asterisk prop="renew_content">
                <el-input type="textarea" v-model="form.renew_content" placeholder="请输入" :maxlength="2000" show-word-limit
                  clearable :autosize="{ minRows: 3 }" @change="
                    clearRule(
                      'advertisementUpdate',
                      'permissionUpdate',
                      'centre_sdk_up'
                    )
                    "></el-input>
              </el-form-item>
              <!-- 说明 -->
              <el-popover placement="top-start" width="200" trigger="hover" class="popover-box">
                <div>
                  <strong>要求/示例</strong>
                </div>
                <div>
                  <strong>需补充：</strong><br>增长部投放需发版调整的策略内容<br><strong>例如：</strong><br>会员引导、套餐改价、弹窗页面等详细信息（括弧标注渠道，如：信息流）
                </div>
                <el-link type="danger" slot="reference">查看要求/示例</el-link>
              </el-popover>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8" :offset="8">
              <!--  <el-form-item label="隐私政策链接更新">
                <el-input type="textarea" placeholder="请输入" v-model="form.privacy_link" :maxlength="2000"
                  show-word-limit clearable :autosize="{ minRows: 3 }"></el-input>
              </el-form-item> -->
              <el-form-item label="隐私政策链接更新" prop="privacy_link">
                <el-input type="textarea" placeholder="填写权限隐私链接" v-model="form.privacy_link" @change="
                  clearRule(
                    'advertisementUpdate',
                    'productUpdate',
                    'centre_sdk_up'
                  )
                  " show-word-limit clearable></el-input>
              </el-form-item>
              <el-popover placement="top-start" width="200" trigger="hover" class="popover-box">
                <div>
                  <strong>要求/示例</strong>
                </div>
                <div>
                  <strong>要求：</strong><br>隐私政策链接有更新时才填写，无更新不填。<br>填写时只需要填对应的隐私链接，不用填写具体的更新内容，并且需要列举出是哪个渠道的隐私链接做了更新<br><strong>示例：</strong><br>华为:https://weatherope1.com/privacy_policy.html?channel=huawei<br>oppo:https://weatherope1.com/privacy_policy.html?channel=oppo
                </div>
                <el-link type="danger" slot="reference">查看要求/示例</el-link>
              </el-popover>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="8" :offset="8">
              <el-form-item label="广告更新" prop="member_adv">
                <el-input type="textarea" placeholder="请输入" v-model="form.member_adv" :maxlength="2000" show-word-limit
                  @change="
                    clearRule(
                      'permissionUpdate',
                      'productUpdate',
                      'centre_sdk_up'
                    )
                    " clearable :autosize="{ minRows: 3 }"></el-input>
              </el-form-item>
              <!-- 说明 -->
              <el-popover placement="top-start" width="300" trigger="hover" class="popover-box">
                <div>
                  <strong>要求/示例</strong>
                </div>
                <div>
                  <strong>示例：</strong><br>1、升级SDK，包括广告SDK、穿山甲、toponSDK；<br>2、修复开屏启动崩溃bug；<br>3、新增XXX广告位；<br>4、新增获取oaid；<br>5、修复老用户获取不到imei的问题；<br>6、新增topon；<br>7、新增bidding；<br>8、新增新用户保护策略：注册24小时内的用户，不展示开屏；<br>9、调整用户注册时机：从拉取开屏后，调整至拉取开屏前；<br>各SDK版本号：<br>广告SDK：<br>穿山甲：<br>穿山甲聚合：<br>广点通：<br>快手：<br>百度：<br>topon：<br>统计SDK:
                </div>
                <el-link type="danger" slot="reference">查看要求/示例</el-link>
              </el-popover>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8" :offset="8">
              <el-form-item label="会员更新" prop="member_order">
                <el-input type="textarea" placeholder="请输入" v-model="form.member_order" :maxlength="2000" show-word-limit @change="
                  clearRule(
                    'permissionUpdate',
                    'productUpdate',
                    'centre_sdk_up'
                  )
                  " clearable :autosize="{ minRows: 3 }"></el-input>
              </el-form-item>
              <!-- 说明 -->
              <el-popover placement="top-start" width="200" trigger="hover" class="popover-box">
                <div>
                  <strong>要求/示例</strong>
                </div>
                <div>更新需求描述+（配置维度）<br><strong>例如：</strong><br>1.增加全屏会员弹窗（在线配置维度：新老用户、首购复购、渠道等等）</div>
                <el-link type="danger" slot="reference">查看要求/示例</el-link>
              </el-popover>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8" :offset="8">
              <el-form-item label="中台统计更新" prop="centre_sdk_up">
                <el-input type="textarea" placeholder="请输入" v-model="form.centre_sdk_up" :maxlength="2000" show-word-limit @change="
                  clearRule(
                    'permissionUpdate',
                    'productUpdate',
                    'advertisementUpdate'
                  )
                  " clearable :autosize="{ minRows: 3 }"></el-input>
              </el-form-item>
              <!-- 说明 -->
              <el-popover placement="top-start" width="200" trigger="hover" class="popover-box">
                <div>
                  <strong>要求/示例</strong>
                </div>
                <div>
                  本次更新统计SDK版本号，以及更新此版本原因/解决的问题<br><strong>示例：</strong>统计SDK：1.2.2<br><strong>原因：</strong>解决老版本SDK获取不到OAID的问题
                </div>
                <el-link type="danger" slot="reference">查看要求/示例</el-link>
              </el-popover>
            </el-col>
          </el-row>
        </el-collapse-item>

        <el-collapse-item title="异常信息" name="3" v-if="false">
          <el-row :gutter="20">
            <el-col :span="6" :offset="8">
              <el-form-item label="审核异常平台">
                <el-cascader v-model="form.auditException" @change="cascderChange" :options="second_channels"
                  placeholder="请选择" :props="cascaderProps" collapse-tags clearable filterable>
                </el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8" :offset="8">
              <!-- prop="violationReason" -->
              <el-form-item label="违规原因/截图:">
                <el-input type="textarea" v-model="form.violationReason" placeholder="请输入" :maxlength="2000"
                  show-word-limit clearable :autosize="{ minRows: 3 }"
                  @change="clearRule('reasonImg', 'violationReason')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16" :offset="8">
              <!-- prop="publishImg" -->
              <el-form-item>
                <AliUpload v-model="form.reasonImg" :limit="5" :drag="true" :listType="''">
                </AliUpload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <!-- prop="violationPublish" -->
            <el-col :span="8" :offset="8">
              <el-form-item label="违规处罚/截图:">
                <el-input type="textarea" v-model="form.violationPublish" placeholder="请输入" :maxlength="2000"
                  show-word-limit clearable :autosize="{ minRows: 3 }"
                  @change="clearRule('publishImg', 'violationPublish')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16" :offset="8">
              <!-- prop="publishImg" -->
              <el-form-item>
                <AliUpload v-model="form.publishImg" :limit="5" :drag="true" :listType="''">
                </AliUpload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>
      <el-row :gutter="20" style="margin-left: 0; margin-right: 0; background: #fff">
        <el-col :span="21" style="background: #fff; text-align: center">
          <el-form-item style="margin-bottom: 22px">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" @click="submitForm('form')">确定</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
// import SelectCustomize from "@/component/select-customize";
import AliUpload from "../component/ali_upload.vue";
import { index_add } from "./mixins/add";
export default {
  // SelectCustomize,
  components: { AliUpload },
  mixins: [index_add],
  data() {
    return {
      // 表格项
      form: {
        appid: "", //应用
        version: "", //版本号
        date: "", //时间
        product_admin_id: "", //产品负责人
        remarks: "", //备注1
        renew_content: "", //产品功能更新
        privacy_link: "", //权限隐私更新
        // privacy_link: "", //隐私链接
        member_adv: "", //广告更新
        member_order: "", //会员更新
        centre_sdk_up: "", //中台统计更新
        // auditException: [], //审核异常平台
        // violationReason: "", //违规原因/异常截图
        // reasonImg: [], //异常截图

        // violationPublish: "", //违规处罚/原件截图
        // publishImg: [], //原件截图
      },
      appidInfo: {
        appInfo: [], //应用-组件列表数据
      },
      application: [], //应用字段
      loadingstate: false, //图片上传之前的加载
      photoAlbum: {
        photoReason: "", //违规原因截图上传
        photoPublish: "", //违规处罚截图上传
      }, //两个上传照片成功的存储位置
      activeNames: ["1", "2", "3"], //折叠面板默认显示的图层
      labelPosition: "right", //表单文字对齐

      cascaderProps: {
        multiple: true,
        value: "id",
        label: "title",
        children: "children",
      },
      backSource: {}, //获取回传的编辑数据
      authorList: [], //协作者列表
      versionNum: true, //版本号禁用
      versionPopover: false, //提示框
      versionV2: [], //版本号存放数据
      second_channels: [], //审核异常平台二级选择框
      channelsSecond: "", //审核异常平台提交数据
      fullscreenLoading: false, //全屏加载
      appDisabled: false,
    };
  },
  mounted() {
    //获取渠道分类
    if (localStorage.getItem("details")) {
      //获取应用数据
      this.fullscreenLoading = true;
      this.backSource = JSON.parse(localStorage.getItem("details"));
      this.getSource();
    }
    // this.getClassify();
    this.application = JSON.parse(localStorage.getItem("appinfo"));
    //请求负责人列表
    this.getAuthor();

  },
  beforeDestroy() {
    localStorage.removeItem("details");
  },
  methods: {
    //获取渠道分类
    async getClassify() {
      let res = await this.$http.post("Invest_Statistics/classify");
      this.second_channels = res[1];
      this.second_channels.forEach(({ id }) => {
        this.getChannels(id);
      });
    },
    //获取渠道
    async getChannels(id) {
      let [err, res] = await this.$http.post(
        "Invest_Statistics/invest_channels",
        { classify_id: id }
      );
      if (err) return;
      if (id == 1) {
        // this.second_channels[0].children = res[1]
        this.$set(this.second_channels[0], "children", res);
      } else if (id == 2) {
        this.$set(this.second_channels[1], "children", res);
      } else if (id == 4) {
        this.$set(this.second_channels[2], "children", res);
      }
      //为避免second_channels还未拼接完毕再次重新赋值
      if (localStorage.getItem("details") !== null) {
        await this.dealBack(); //处理回显的块联选择
        await this.getSource();
        // this.fullscreenLoading = true
        this.fullscreenLoading = false;
      }
    },
    //获取存储的下拉菜单数据
    async getSource() {
      this.appDisabled = true;
      this.versionNum = true;
      this.versionPopover = false;
      //回传后的赋值操作、
      this.form = this.backSource
      this.form.product_admin_id = this.backSource.product_admin_id + ''
      this.fullscreenLoading = false
      // let {
      //   appid,
      //   renew_content,
      //   privacy_link,
      //   increase_admin_id,
      //   commerce_admin_id,
      //   product_admin_id,
      //   member_adv,
      //   centre_sdk_up,
      //   version,
      //   remarks,
      //   date,
      //   violation,
      //   punish,
      // } = this.backSource;
      // this.form.name = appid + "";
      // this.form.productUpdate = renew_content;
      // this.form.permissionUpdate = privacy_link;
      // this.form.collaborator = increase_admin_id + "";
      // this.form.commercial = commerce_admin_id + "";
      // this.form.responsible = product_admin_id + "";
      // this.form.advertisementUpdate = member_adv;
      // this.form.centre_sdk_up = centre_sdk_up;
      // this.form.violationReason = violation.cause;
      // this.form.versionNum = version;
      // this.form.violationPublish = punish.cause;
      // this.form.remarks = remarks;
      // this.form.time = date.split(" ")[0];
      // this.form.reasonImg = violation.image;
      // this.form.publishImg = punish.image;

    },
    //处理块联回显
    dealBack() {
      let arr = [];
      this.backSource.err_platform.split(",").forEach((item) => {
        this.second_channels.forEach(({ children }) => {
          if (children) {
            children.forEach((val) => {
              if (item == val.id) {
                arr.push(val);
              }
            });
          }

        });
      });
      for (const i of arr) {
        let group = [i.classify_id, i.id];
        this.form.auditException.push(group);
      }
    },
    //获取协作者列表
    async getAuthor() {
      let res = await this.$http.post("Operate_Invest/getAuthor");
      this.authorList = res[1].admin;
    },

    //表单取消
    cancel() {
      this.$router.push({
        path: "/business_center/subsidiary_management/app_auditing",
        query: {
          id: 32,
          componentName: "Index",
        },
      });
    },
    //表单提交
    submitForm(form) {
      console.log(this.$refs[form].validate);
      this.$refs[form].validate((valid) => {
        console.log(valid);
        if (valid) {
          console.log(1);
          this.$http.post("/release/add_change", this.form).then((res) => {
            if (res[3] == "success") {
              this.$message.success("提交成功");
              setTimeout(() => {
                this.cancel();
              }, 200);
            } else {
              this.$message.error(res[0].msg);
            }
          });
        } else {
          this.$message.error("请填写完成后再进行提交");
          return false;
        }
      });
    },
    //更新内容栏，三选一校验规则判定
    clearRule(obj, obj1, obj2) {
      this.$refs["form"].clearValidate(obj);
      this.$refs["form"].clearValidate(obj1);
      this.$refs["form"].clearValidate(obj2);
    },
    //异常信息,二填一校验
    resetRule(obj) {
      this.$refs["form"].clearValidate(obj);
    },
    // 筛选应用的回调函数
    async changeAppid(val) {
      this.form.version = "";
      if (this.form.appid !== "") {
        await this.getVersionV2(val);
        this.versionNum = false;
        this.versionPopover = true;
      } else {
        this.versionNum = true;
        this.versionPopover = false;
      }
    },
    //获取版本号
    async getVersionV2(id) {
      let res = await this.$http.post("App/getVersionV2", { appId: id });
      this.versionV2 = Array.from(new Set(res[1]));
    },
    //块联选择框的值
    cascderChange(val) {
      let arr = [];
      val.forEach((vals) => {
        arr.push(vals[1]);
      });
      this.channelsSecond = Array.from(new Set(arr)).join(",");
    },
    versionChange(val) {
      this.$http
        .post("/release/repeat", {
          appid: this.form.appid,
          version: val,
        })
        .then((res, err) => {
          if (err) return;
          if (res[1].is_repeat == true) {
            this.$message.error("已添加过该版本号,请重新选择");
            this.form.version = "";
          }
        });
    },
  },

};
</script>

<style scoped>
.required::before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
</style>
<style>
.el-upload-dragger {
  margin-top: 22px;
}

.el-collapse-item__header {
  height: 30px;
  background: #ddd;
  padding-left: 10px;
  color: #303133;
}

.el-form-item {
  margin-bottom: 0;
  margin-top: 22px;
}

.el-col-xl-6 {
  margin-bottom: 20px;
}

.el-textarea .el-input__count {
  bottom: 0;
  background: transparent;
}

.el-textarea__inner {
  padding: 5px 15px 30px;
}
</style>
<style>
.el-popover {
  white-space: break-spaces !important;
}

.el-col {
  position: relative;
}

.popover-box {
  position: absolute;
  top: 65px;
  left: 70px;
}
</style>